<template>
  <div class="tripadvisor-wrapper in-list tripadvisor-searched">
    <tk-link
      class="tripadvisor-link"
      style="z-index: 1;"
      @click.prevent="$emit('clicked')"
    >
      <div class="hotel_adRating">
        <p class="title">トリップアドバイザー評価</p>
        <div style="padding-top: 3px;">
          <p class="rating-wrapper">
            <tk-image alt="tripadvisor rating" :image-path="ratingImageUrl" />
            <span class="rating-text">
              <span class="rating-value">{{ ratingValue }}</span>
              /5
            </span>
          </p>
          <p>
            口コミ数：<span class="review-count">{{ reviewCount }}</span>
            件
          </p>
        </div>
      </div>
    </tk-link>
  </div>
</template>

<script>
import TkLink from '../../atoms/TkLink/TkLink'
import TkImage from '../../atoms/TkImage/TkImage'

export default {
  name: 'TkTripadvisorRating',
  components: {
    TkLink,
    TkImage,
  },
  props: {
    reviewCount: {
      type: Number,
      required: true,
    },
    ratingImageUrl: {
      type: String,
      required: true,
    },
    ratingValue: {
      type: String,
      required: true,
    },
  },
}
</script>
